"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const universal_base64_1 = require("universal-base64");
function decode(str) {
    return universal_base64_1.decode(str.replace(/\-/g, "+").replace(/_/g, "/"));
}
exports.decode = decode;
function encode(str) {
    return universal_base64_1.encode(str)
        .replace(/\//g, "_")
        .replace(/\+/g, "-")
        .replace(/=+$/, "");
}
exports.encode = encode;
//# sourceMappingURL=index.js.map